'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analyticsRevenue = require('./analytics-revenue.html');

var _analyticsRevenue2 = _interopRequireDefault(_analyticsRevenue);

var _analyticsRevenue3 = require('./analytics-revenue.controller');

var _analyticsRevenue4 = _interopRequireDefault(_analyticsRevenue3);

require('./analytics-revenue.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsComponent = {
  restrict: 'E',
  bindings: {},
  template: _analyticsRevenue2.default,
  controller: _analyticsRevenue4.default,
  controllerAs: 'vm'
};

exports.default = analyticsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-revenue/analytics-revenue.component.js
 **/